import request from '@/util/request'
import Qs from 'qs'
import cloneDeep from 'lodash.clonedeep'
import {
  getAPILangParam,
  JSON_CONFIG,
  FORM_CONFIG,
  templateIsFinish
} from '@/util/helper.js'

export function getTemplates () {
  return request({
    url: '/misc/schedule',
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getTemplate (id, withoutLevel = 0, cancelToken) {
  return request({
    url: `/misc/schedule/${id}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam(),
      withoutLevel: withoutLevel
    },
    cancelToken: cancelToken
  })
}

export function restoreTemplate (id) {
  return request({
    url: `/misc/schedule/${id}/restore`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function copyTemplate (templateId, title) {
  return request({
    url: `/misc/schedule/copy`,
    method: 'POST',
    header: FORM_CONFIG,
    data: Qs.stringify({
      id: templateId,
      title: title
    })
  })
}

export function getTemplateLevelDetail (scheduleId, level) {
  return request({
    url: `/misc/schedule/${scheduleId}/level/${level}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function updateTemplateLevel (scheduleId, data) {
  return request({
    url: `/misc/schedule/${scheduleId}/level`,
    method: 'post',
    header: JSON_CONFIG,
    data: data
  })
}

export function deleteTemplateLevel (scheduleId, level) {
  return request({
    url: `/misc/schedule/${scheduleId}/level/${level}`,
    method: 'delete',
    header: JSON_CONFIG
  })
}

export function restoreTemplateLevel (scheduleId, data) {
  return request({
    url: `/misc/schedule/${scheduleId}/level/restore`,
    method: 'post',
    header: JSON_CONFIG,
    data: data
  })
}

export function getLevelUpCondition () {
  return request({
    url: '/misc/levelUpTarget',
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function updateNameAndDefault (id, name, isDefault) {
  return request({
    url: `/misc/schedule/${id}`,
    method: 'post',
    header: FORM_CONFIG,
    data: Qs.stringify({
      name: name,
      isDefault: isDefault
    })
  })
}

export function createTemplate (data) {
  return request({
    url: '/misc/schedule',
    method: 'post',
    header: JSON_CONFIG,
    data: data
  })
}

export function deleteTemplate (id) {
  return request({
    url: `/misc/schedule/${id}`,
    method: 'delete',
    header: JSON_CONFIG
  })
}

export function updateTemplate (id, data) {
  // TODO: 可以調整在調用前先處理 data
  let temp = cloneDeep(data)
  delete temp.id

  for (let index = 0; index < temp.level.length; index++) {
    delete temp.level[index].exercises
    delete temp.level[index].isEarly
  }
  temp.isFinish = templateIsFinish(temp)

  return request({
    url: `/misc/schedule/${id}`,
    method: 'put',
    header: JSON_CONFIG,
    data: temp
  })
}



// WEBPACK FOOTER //
// ./src/api/template.js